import { render, staticRenderFns } from "./PopAllocation.vue?vue&type=template&id=695eeae2&scoped=true&"
import script from "./PopAllocation.vue?vue&type=script&lang=js&"
export * from "./PopAllocation.vue?vue&type=script&lang=js&"
import style0 from "./PopAllocation.vue?vue&type=style&index=0&id=695eeae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695eeae2",
  null
  
)

export default component.exports